import { createAction, props } from '@ngrx/store';
import { Club } from './clubs.model';

// fetch 
export const fetchclublistData = createAction('[Data] fetch clublist');
export const fetchclublistSuccess = createAction('[Data] fetch clublist success', props<{ ClubListdata: Club[] }>())
export const fetchclublistFail = createAction('[Data fetch clublist failed]', props<{ error: string }>())

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record club'
);

export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record club success', 
    props<{ singleData: Club }>()
);

export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record club failure', 
    props<{ error: string }>()
);


//Reset State
export const resetState = createAction(
    '[Data] reset state club',
);